import { CoreWebService } from './core-web.service';
import { Injectable } from '@angular/core';
import { LoginService } from './login.service';
import { DotcmsEventsService } from './dotcms-events.service';
import { RequestMethod } from '@angular/http';
import { DotRouterService } from './dot-router.service';
import { Subject } from 'rxjs/Subject';
var RoutingService = (function () {
    // TODO: I think we should be able to remove the routing injection
    function RoutingService(loginService, router, coreWebService, dotcmsEventsService) {
        this.loginService = loginService;
        this.router = router;
        this.coreWebService = coreWebService;
        this._menusChange$ = new Subject();
        this._portletUrlSource$ = new Subject();
        this._currentPortlet$ = new Subject();
        this.urlMenus = 'v1/CORE_WEB/menu';
        this.portlets = new Map();
        loginService.watchUser(this.loadMenus.bind(this));
        dotcmsEventsService
            .subscribeTo('UPDATE_PORTLET_LAYOUTS')
            .subscribe(this.loadMenus.bind(this));
    }
    Object.defineProperty(RoutingService.prototype, "currentPortletId", {
        get: function () {
            return this._currentPortletId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoutingService.prototype, "currentMenu", {
        get: function () {
            return this.menus;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoutingService.prototype, "menusChange$", {
        get: function () {
            return this._menusChange$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoutingService.prototype, "portletUrl$", {
        get: function () {
            return this._portletUrlSource$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoutingService.prototype, "firstPortlet", {
        get: function () {
            var porlets = this.portlets.entries().next().value;
            return porlets ? porlets[0] : null;
        },
        enumerable: true,
        configurable: true
    });
    RoutingService.prototype.addPortletURL = function (portletId, url) {
        this.portlets.set(portletId.replace(' ', '_'), url);
    };
    RoutingService.prototype.getPortletURL = function (portletId) {
        return this.portlets.get(portletId);
    };
    RoutingService.prototype.goToPortlet = function (portletId) {
        this.router.gotoPortlet(portletId);
        this._currentPortletId = portletId;
    };
    RoutingService.prototype.isPortlet = function (url) {
        var id = this.getPortletId(url);
        if (id.indexOf('?') >= 0) {
            id = id.substr(0, id.indexOf('?'));
        }
        return this.portlets.has(id);
    };
    RoutingService.prototype.setCurrentPortlet = function (url) {
        var id = this.getPortletId(url);
        if (id.indexOf('?') >= 0) {
            id = id.substr(0, id.indexOf('?'));
        }
        this._currentPortletId = id;
        this._currentPortlet$.next(id);
    };
    Object.defineProperty(RoutingService.prototype, "currentPortlet$", {
        get: function () {
            return this._currentPortlet$;
        },
        enumerable: true,
        configurable: true
    });
    RoutingService.prototype.logout = function () {
        this.loginService.logOutUser().subscribe();
    };
    RoutingService.prototype.setMenus = function (menus) {
        this.menus = menus;
        if (this.menus.length) {
            this.portlets = new Map();
            for (var i = 0; i < this.menus.length; i++) {
                var menu = this.menus[i];
                for (var k = 0; k < menu.menuItems.length; k++) {
                    var subMenuItem = menu.menuItems[k];
                    if (subMenuItem.angular) {
                        this.portlets.set(subMenuItem.id, subMenuItem.url);
                    }
                    else {
                        subMenuItem.menuLink = '/c/' + subMenuItem.id;
                        this.portlets.set(subMenuItem.id, subMenuItem.url);
                    }
                }
            }
            this._menusChange$.next(this.menus);
        }
    };
    /**
     * Refresh the portlet displayed. with the
     * @param url portlet url
     */
    RoutingService.prototype.changeRefreshPortlet = function (url) {
        var portletId = this.getPortletId(url);
        if (portletId === this.currentPortletId) {
            this._portletUrlSource$.next(url);
        }
    };
    RoutingService.prototype.loadMenus = function () {
        var _this = this;
        this.coreWebService
            .requestView({
            method: RequestMethod.Get,
            url: this.urlMenus
        })
            .subscribe(function (response) {
            _this.setMenus(response.entity);
        }, function (error) { return _this._menusChange$.error(error); });
    };
    RoutingService.prototype.getPortletId = function (url) {
        var urlSplit = url.split('/');
        return urlSplit[urlSplit.length - 1];
    };
    return RoutingService;
}());
export { RoutingService };
RoutingService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
RoutingService.ctorParameters = function () { return [
    { type: LoginService, },
    { type: DotRouterService, },
    { type: CoreWebService, },
    { type: DotcmsEventsService, },
]; };
//# sourceMappingURL=routing.service.js.map